import { Routes } from '@angular/router';

export const insuranceRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'list',
  },
  {
    path: 'list',
    loadComponent: () => import('./insurance-list/insurance-list.page').then((m) => m.InsuranceListPage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'insurance-search',
    loadComponent: () => import('./insurance-search/insurance-search.page').then((m) => m.InsuranceSearchPage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'add-insurance',
    loadComponent: () => import('./add-insurance/add-insurance.page').then((m) => m.AddInsurancePage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'capture',
    loadComponent: () => import('./capture-card/capture-card.page').then((m) => m.CaptureCardPage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'capture-check',
    loadComponent: () => import('./capture-check/capture-check.page').then((m) => m.CaptureCheckPage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'confirm',
    loadComponent: () => import('./create-confirmation/create-confirmation.page').then((m) => m.CreateConfirmationPage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'manually-add-insurance',
    loadComponent: () =>
      import('./manually-add-insurance/manually-add-insurance.page').then((m) => m.ManuallyAddInsurancePage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'update/:id',
    loadComponent: () =>
      import('./update-insurance/update-insurance.component').then((m) => m.UpdateInsuranceComponent),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'update/:id/confirm',
    loadComponent: () => import('./update-confirmation/update-confirmation.page').then((m) => m.UpdateConfirmationPage),
    data: {
      shouldShowTabBar: false,
    },
  },
];
